import { AuthLayout } from "@/components/layout/auth-layout";
import { supabase } from "@/lib/supabase";
import { withTimeout, TIMEOUT, LOAD_STALL_MS } from "@/lib/with-timeout";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)")({
  beforeLoad: async () => {
    // Bound the wait so a wedged network can't trap the user on a spinner before
    // sign-in. On timeout, treat as not-known-authed and just render sign-in.
    const result = await withTimeout(supabase.auth.getSession(), LOAD_STALL_MS);

    if (result !== TIMEOUT && result.data.session?.user) {
      throw redirect({
        to: "/",
        replace: true,
      });
    }
  },
  component: AuthLayout,
});
